import Icon, { IconType } from 'components/Icon';
import Chip from 'components/Widget/Chip';
import { useTheme } from 'styled-components';
import { getAvatarGradient, getInitials, logout } from 'utils';
import * as S from './styles';
import type { UiColor } from 'tokens';

interface HeaderProps {
	title: string;
	email: string;
	planBadgeColor?: UiColor;
	planBadgeLabel: string;
	onEdit?: () => void;
	showSignOut?: boolean;
}

const Header = ({
	title,
	email,
	planBadgeColor,
	planBadgeLabel,
	onEdit,
	showSignOut = true,
}: HeaderProps) => {
	const theme = useTheme();

	return (
		<S.Base>
			<S.Content>
				<S.Left>
					<S.UserAvatar style={{ background: getAvatarGradient(title || email || '', theme) }}>
						{getInitials(title || email || '')}
					</S.UserAvatar>
					<S.Info>
						<S.TitleRow>
							<S.Title>{title || 'Account'}</S.Title>
							{onEdit && (
								<S.EditButton onClick={onEdit}>
									<Icon type={IconType.EDIT} width={18} height={18} color={theme.gray[600]} />
								</S.EditButton>
							)}
						</S.TitleRow>
						<S.Email>{email}</S.Email>
						<S.ChipWrapper>
							<Chip label={planBadgeLabel} color={planBadgeColor} />
						</S.ChipWrapper>
					</S.Info>
				</S.Left>
				{showSignOut && (
					<S.Right>
						<S.LogoutButton onClick={() => logout()}>
							Sign out
							<Icon type={IconType.LINE_ARROW_RIGHT} width={12} height={12} color="currentColor" />
						</S.LogoutButton>
					</S.Right>
				)}
			</S.Content>
		</S.Base>
	);
};

export default Header;
